import { FlexContainer } from '@/ui/styled-ui';
import { RiskyUsersIcon } from '@/utils/helpers/icons.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ChartContainer = styled(FlexContainer)`
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  height: max-content;
  border: 1px solid var(--gray-medium);
  border-radius: var(--xsmall-border-radius);
  padding: var(--default-padding);
  background: var(--white-main);
  gap: var(--small-padding);
`;

const HeaderContainer = styled(FlexContainer)`
  flex: 1;
  justify-content: flex-start;
  align-items: space-between;
  width: 100%;
  min-height: 100%;
  gap: var(--small-padding);
  border-right: 1px solid var(--gray-medium);
  padding-right: var(--semi-big-padding);
`;

const IconContainer = styled(FlexContainer)`
  justify-content: center;
  align-items: center;
  min-width: 38px;
  max-width: 38px;
  min-height: 38px;
  max-height: 38px;
  color: var(--red-main);
  background: var(--red-pale);
  border-radius: var(--xsmall-border-radius);
  align-self: center;
`;

const HeaderText = styled.h3`
  align-self: flex-start;
  margin: 0;
  font-size: var(--semi-big-font-size);
  line-height: var(--semi-big-line-height);
  font-weight: 700;
  color: var(--black-main);
`;

const DescriptionText = styled.p`
  margin: 0;
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  width: 100%;
`;

const CountContainer = styled(FlexContainer)`
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: var(--small-padding) 0;
`;

const CountText = styled.h1`
  margin: 0;
  font-size: 48px;
  line-height: 56px;
  font-weight: 700;
  color: var(--black-main);
`;

const ExplanationText = styled(FlexContainer)`
  flex: 1;
  margin: 0;
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  width: 100%;
  min-height: 100%;
  border-left: 1px solid var(--gray-medium);
  padding-left: var(--semi-big-padding);

  p {
    margin: 0;
    align-self: center;
  }
`;

type TotalVulnerableUsersProps = {
  vulnerableUsersCount: number;
  isLoading: boolean;
};

export const TotalVulnerableUsers = ({
  vulnerableUsersCount,
  isLoading,
}: TotalVulnerableUsersProps) => {
  const { t } = useTranslation();

  return (
    <ChartContainer id="total-vulnerable-users-chart">
      <HeaderContainer>
        <IconContainer>
          <RiskyUsersIcon />
        </IconContainer>
        <FlexContainer direction="column" align="center">
          <HeaderText>
            {t('phishing.analytics.totalVulnerableUsers')}
          </HeaderText>
          <DescriptionText>
            {t('phishing.analytics.totalVulnerableUsers.description')}
          </DescriptionText>
        </FlexContainer>
      </HeaderContainer>

      <CountContainer>
        {isLoading ? (
          <CountText>--</CountText>
        ) : (
          <CountText>{vulnerableUsersCount}</CountText>
        )}
      </CountContainer>

      <ExplanationText>
        <p>{t('phishing.analytics.totalVulnerableUsers.explanation')}</p>
      </ExplanationText>
    </ChartContainer>
  );
};
